module.exports = {
  PASSWORD_REGEX: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})",
  TELEGRAM_USERNAME_REGEX: "^(@?)[A-Za-z]{1}[A-Za-z_0-9]{3,}[A-Za-z0-9]{1}$",
  SEARCH_TRANSACTIONS_REGEX: "^([0-9a-zA-z#?!@$%^&*-]+)((, +| +, +| + ,|, |,| ,| , )([0-9a-zA-z#?!@$%^&*-]+))*$",
  // eslint-disable-next-line no-useless-escape
  IP_ADDRESS_REGEX: "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
};